import React, { useState } from 'react';
import styled from 'styled-components';

// Components
import BannerInternationalWorkshop from './BannerInternationalWorkshop';
/* import PhysicalEvents from "./PhysicalEvents"; */
import OnlineEvents from './components/OnlineEvents';
import Tabs from '../../components/common/Tabs';
import Graduation from './Graduation';
import ClassesEvents from './components/ClassesEvents';

// Hooks
import { useQueryParams } from '../../hooks/useQueryParams';

// Helpers
import { titleHTML } from '../../helpers/title.helper';

const Events = () => {
    titleHTML('Talleres presenciales');

    const queryTab = useQueryParams();
    const initialTab =
        queryTab.get('tab') === 'physical-events'
            ? 1
            : queryTab.get('tab') === 'online-events'
              ? 0
              : queryTab.get('tab') === 'international-workshop'
                ? 2
                : queryTab.get('tab') === 'online-classes'
                  ? 3
                  : queryTab.get('tab') === 'physical-classes'
                    ? 4
                    : 3;

    //STATES
    const [currentTab, setCurrentTab] = useState(initialTab);

    const OPTIONS = [
        {
            id: 3,
            label: 'Clases online',
        },
        {
            id: 4,
            label: 'Clases presenciales',
        },
        {
            id: 0,
            label: 'Eventos online',
        },
        {
            id: 1,
            label: 'Eventos presenciales',
        },
        // {
        //     id: 2,
        //     label: 'Workshops internacionales',
        // },
    ];

    const compareDates = (date) => {
        const dateParts = date.split('-');
        const dateObject = new Date(
            dateParts[0],
            dateParts[1] - 1,
            dateParts[2]
        );
        dateObject.setHours(0, 0, 0, 0);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return dateObject < today;
    };

    const workshops = [
        {
            title: 'LATAM meets Silicon Valley 2026',
            description: '',
            country: 'Silicon Valley',
            date: '27 al 30 de Mayo, 2026',
            id: 5,
            img: './assets/internationalWorkshop/Workshop-SV.png',
            description_complete: '',
            link: 'https://www.aden.org/workshop-silicon-valley/',
            untilDate: 'Miércoles 20 de Mayo',
            briefing: 'Lunes 27 de Abril',
            disabled: compareDates('2026-05-20'),
            pdf: 'https://drive.google.com/file/d/1JConnrNmIzRJvd65K9fdkNJL4FKAOFRW/view?usp=sharing',
            // location: 'Hotel Pullman Miami Airport',
        },
        {
            title: 'Innovación, Tecnología y Tendencias',
            description: '',
            country: 'Miami',
            date: '18 al 20 de noviembre 2026',
            id: 3,
            img: './assets/internationalWorkshop/nuevas-tecnologias.png',
            description_complete: '',
            link: 'https://www.aden.org/programa/workshop-miami/',
            // untilDate: 'Lunes 3 de Noviembre',
            // briefing: 'Miércoles 01 de Octubre',
            disabled: compareDates('2026-11-03'),
            // pdf: 'https://drive.google.com/file/d/1o26dT_QdNRBPt38wOdO6M3nYCLK8AlXN/view?usp=sharing',
            // location: 'Hotel Pullman Miami Airport',
        },
        {
            title: 'Workshop Washington',
            description: '',
            country: 'Washington',
            date: '7 al 9 de octubre de 2026',
            id: 4,
            img: './assets/internationalWorkshop/washington-ws.png',
            description_complete: '',
            link: 'https://www.aden.org/programa/workshop-washington/',
            // untilDate: 'Miércoles 1 de Octubre',
            // briefing: 'Lunes 22 de Septiembre',
            disabled: compareDates('2026-10-01'),
            // pdf: 'https://drive.google.com/file/d/1AwTkPfRjwIJyeJeeFsmhE8mhSeHu_gVq/view?usp=sharing',
            // location: 'Hotel Pullman Miami Airport',
        },
        {
            title: 'El impacto de la IA',
            description: '',
            country: 'Barcelona',
            date: '8 al 10 de septiembre 2026',
            id: 6,
            img: './assets/internationalWorkshop/innovacion.png',
            description_complete: '',
            link: 'https://www.aden.org/programa/workshop-barcelona/',
            // untilDate: 'Viernes 29 de Agosto',
            // briefing: 'Jueves 14 de Agosto',
            disabled: compareDates('2026-08-30'),
            // pdf: 'https://drive.google.com/file/d/17JfGGQOHfqfz6Svg6LbNf_U8q4_JHn-F/view?usp=sharing',
            // location: 'C/ de Rosselló i Pòrcel, 7-11',
        },
    ];

    const ActiveTabContent = () => {
        if (currentTab === 0) {
            return <OnlineEvents type="online" />;
        }

        if (currentTab === 1) {
            return <OnlineEvents type="physical" />;
        }

        if (currentTab === 3) {
            return <ClassesEvents isOnline={true} />;
        }

        if (currentTab === 4) {
            return <ClassesEvents isOnline={false} />;
        }

        if (currentTab === 2) {
            return (
                <WrapperWorkshop>
                    <WrapperCard>
                        <BannerInternationalWorkshop />
                        <Container>
                            <Graduation workshops={workshops} />
                        </Container>
                    </WrapperCard>
                </WrapperWorkshop>
            );
        }
        return <div></div>;
    };

    return (
        <>
            <TabsWrapper>
                <Tabs
                    tabValue={currentTab}
                    handleTabValue={setCurrentTab}
                    tabOptions={OPTIONS}
                />
            </TabsWrapper>
            <Container style={{ marginTop: '50px' }}>
                <ActiveTabContent />
            </Container>
        </>
    );
};

export default Events;

const Container = styled.div`
    display: flex;
    overflow: hidden;
    border-radius: 20px;
    flex-direction: column;
    row-gap: 2rem;
`;

const TabsWrapper = styled.div`
    width: calc(100% - 6rem - 70px);
    position: fixed;
    left: 70px;
    top: 70px;
    z-index: 10;
    border-top: 1px solid #f7f7f7;
    padding: 0 3rem;
    background-color: #ffffff;
    @media (max-width: 768px) {
        left: 0;
        width: calc(100% - 6rem);
    }
`;

const WrapperWorkshop = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    gap: 3rem;
    height: 100%;
`;

const WrapperCard = styled.div`
    width: calc(100% - 48px);
    box-shadow:
        0px 12px 24px -15px #0000001a,
        0px 0px 10px -6px #00000040;
    border-radius: 20px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    background-color: #fff;
`;
